import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { buildApiUrl } from "../../lib/api";
import './MarketClock.css';

const MarketClock = () => {
    const [marketData, setMarketData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

        const [time, setTime] = useState(new Date());
    
        useEffect(() => {
            const timerId = setInterval(() => {
                setTime(new Date());
            }, 1000);
    
            return () => clearInterval(timerId);
        }, []);
    
        const estTime = new Date(time.toLocaleString('en-US', { timeZone: 'America/New_York' }));
        const dayOfWeek = estTime.toLocaleString('en-US', { weekday: 'short' });
        const date = estTime.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });

        useEffect(() => {
            const fetchMarketClock = async () => {
                try {
                    const response = await axios.get(buildApiUrl("/market-clock/"));
                    setMarketData(response.data);
                } catch (err) {
                    setError(err.message);
                } finally {
                    setLoading(false);
                }
            };

            fetchMarketClock();
        }, []);

    if (loading) return <div className="market-clock">Loading market data...</div>;
    if (error) return <div className="market-clock">Error: {error}</div>;

    const { is_open, next_open, next_close } = marketData;

    return (
        <div className="market-clock">
             <div className='time'>
            <div>
            {dayOfWeek}, {date}             {new Date(time).toLocaleTimeString([], {
                timeZoneName: 'short'
            })}
            </div>
            <div>

            </div>
            </div>
            <h2>
                {is_open ? (
                    <>
                        <span style={{ color: 'green', fontSize: '1.5em' }}>●</span> Market Open
                    </>
                ) : (
                    <>
                        <span style={{ color: 'red', fontSize: '1.5em' }}>●</span> Market Closed
                    </>
                )}
            </h2>
            <p>
                {is_open
                    ? `Closes ${new Date(next_close).toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit',
                        timeZoneName: 'short',
                    })}`
                    : `Opens ${new Date(next_open).toLocaleDateString([], {
                        weekday: 'short',
                        month: 'short',
                        day: 'numeric',
                    })} ${new Date(next_open).toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit',
                        timeZoneName: 'short',
                    })}`}
            </p>
        </div>
    );
};

export default MarketClock;
